import { dispatchTopBarTraySelectionEvent } from '@frontend/shared';
import { createStoreWithPersist, createShallowStore } from '@frontend/store';

// eslint-disable-next-line no-shadow
export enum SchedulePulseTab {
  AppointmentRequests = 'schedule-appointment-requests-tab',
  Alerts = 'schedule-alerts-tab',
  AppointmentList = 'schedule-appointments-list-tab',
  Insurance = 'schedule-insurance-tab',
}

type State = {
  selectedTab?: SchedulePulseTab;
  selectedRequestLocationId?: string;
  selectedRequestId?: string;
  appointmentListTabState?: {
    calendarDate?: string; // MM/DD/YYYY
    isUnconfirmedStatusSelected?: boolean;
  };
};

type Actions = {
  setSelectedTab: (tab: SchedulePulseTab) => void;
  setAppointmentListTabState: (state: State['appointmentListTabState']) => void;
  setState: (state: Partial<State>) => void;
  setSelectedRequestLocationId: (locationId: string | null) => void;
  setSelectedRequestId: (requestId: string | null) => void;
};

type Store = State & Actions;

const initialState: State = {};

const useStore = createStoreWithPersist<Store>(
  (set) => ({
    ...initialState,
    setSelectedTab: (tab: SchedulePulseTab) => {
      set({ selectedTab: tab }, false, 'SET_SELECTED_TAB');
    },
    setAppointmentListTabState: (state) => {
      set(
        (prev) => ({
          appointmentListTabState: { ...prev.appointmentListTabState, ...state },
        }),
        false,
        'SET_APPOINTMENT_LIST_TAB_STATE'
      );
    },
    setState: (state) => set(state, false, 'SET_STATE'),
    setSelectedRequestLocationId: (locationId) => {
      set({ selectedRequestLocationId: locationId ?? undefined }, false, 'SET_SELECTED_REQUEST_LOCATION_ID');
    },
    setSelectedRequestId: (requestId) =>
      set({ selectedRequestId: requestId ?? undefined }, false, 'SET_SELECTED_REQUEST_ID'),
  }),
  {
    name: 'schedule-pulse-store',
  },
  {
    name: 'SchedulePulseStore',
    trace: true,
  }
);

export const useSchedulePulseShallowStore = createShallowStore(useStore);

export const openSchedulePulseWithFilters = (state: Partial<State>) => {
  useStore.getState().setState(state);
  dispatchTopBarTraySelectionEvent('schedulePulse');
};

export const openSchedulePulse = (tab: SchedulePulseTab) => openSchedulePulseWithFilters({ selectedTab: tab });

export const openSchedulePulseRequest = (locationId: string, requestId: string) =>
  openSchedulePulseWithFilters({
    selectedRequestLocationId: locationId,
    selectedRequestId: requestId,
    selectedTab: SchedulePulseTab.AppointmentRequests,
  });
